const ImplementationCostCurrentVsLastweek = (initiatives) => {
  const l0ToL2 = ['L0', 'L1', 'L2'];
  const L3ToL5 = ['L3', 'L4', 'L5'];

  const sumAnnuallyPlan = (value) => {
    if (Array.isArray(value)) {
      return value.reduce((sum, val) => sum + (val || 0), 0);
    }
    return value || 0;
  };

  const calculateTotalRecurringBenefit = (initiative) => {
    const impacts = initiative.KPI || [];

    if (!impacts || impacts.length === 0) {
      return NaN; // Indicate no impact
    }

    let recurringBenefit = 0;
    let negativeRecurringImpact = 0;
    let implementationCost=0;
    let totalImplementationCost=0
    if (initiative.stage) {
      if (Array.isArray(initiative.stage)) {
        if (initiative.stage.some((stage) => l0ToL2.includes(stage))) {
          recurringBenefit = impacts
            .filter(
              (impact) =>
                impact.UniversalKPI === 'One Time Implementation for Amortization' ||
                impact.UniversalKPI === 'One Time Implementation Cost for Depreciation'
            )
            .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyPlan), 0);
        } else if (initiative.stage.some((stage) => L3ToL5.includes(stage))) {
          recurringBenefit = impacts
            .filter(
              (impact) =>
                impact.UniversalKPI === 'One Time Implementation for Amortization' ||
                impact.UniversalKPI === 'One Time Implementation Cost for Depreciation'
            )
            .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyActual), 0);
        }
      } else if (typeof initiative.stage === 'string') {
        if (l0ToL2.includes(initiative.stage)) {
          recurringBenefit = impacts
            .filter(
              (impact) =>
                impact.UniversalKPI === 'One Time Implementation for Amortization' ||
                impact.UniversalKPI === 'One Time Implementation Cost for Depreciation'
            )
            .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyPlan), 0);
        } else if (L3ToL5.includes(initiative.stage)) {
          recurringBenefit = impacts
            .filter(
              (impact) =>
                impact.UniversalKPI === 'One Time Implementation for Amortization' ||
                impact.UniversalKPI === 'One Time Implementation Cost for Depreciation'
            )
            .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyActual), 0);
        }
      }
    }

    return recurringBenefit - negativeRecurringImpact;
  };

  const now = new Date();
  const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

  const rangeInitiativesMap = {
    '<not set>': [],
    'Increased by > 1 ETB m': [],
    'Increased by 0.1-1 ETB m': [],
    'Increased by < 0.1 ETB m': [],
    'Unchanged': [],
    'Decreased by < 0.1 ETB m': [],
    'Decreased by 0.1-1 ETB m': [],
    'Decreased by > 1 ETB m': [],
  };

  initiatives.forEach((initiative) => {
    const history = initiative.history || [];
    const impactUpdateHistory = history.filter(
      (entry) =>
        entry.action &&
        entry.action.includes('Impact number') &&
        entry.action.includes('has been updated.')
    );

    const oldImpactHistories = impactUpdateHistory.filter(
      (entry) => new Date(entry.timestamp) < oneWeekAgo
    );

    oldImpactHistories.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    let newNetRecurringBenefit = Array(5).fill(0);
    let previousNetRecurringBenefit = Array(5).fill(0);

    oldImpactHistories.forEach((entry) => {
      if (entry.changes && entry.changes.annuallyPlan && entry.changes.annuallyPlan.new) {
        if (entry.action.includes('One Time Benefit')) {
          for (let i = 0; i < 5; i++) {
            newNetRecurringBenefit[i] += entry.changes.annuallyPlan.new[i] || 0;
            previousNetRecurringBenefit[i] += entry.changes.annuallyPlan.previous[i] || 0;
          }
        }
      }
    });

    const totalNew = newNetRecurringBenefit.reduce((sum, value) => sum + value, 0);
    const totalPrevious = previousNetRecurringBenefit.reduce((sum, value) => sum + value, 0);

    const currentValue = calculateTotalRecurringBenefit(initiative);
    const lastWeekValue = totalNew;

    let range = '<not set>';

    if (isNaN(currentValue)) {
      range = '<not set>'; // Case of no Impact
    } else if (currentValue === lastWeekValue) {
      range = 'Unchanged'; // Case current equals last week
    } else {
      const difference = currentValue - lastWeekValue;

      if (difference > 1000000) {
        range = 'Increased by > 1 ETB m';
      } else if (difference >= 100000 && difference <= 1000000) {
        range = 'Increased by 0.1-1 ETB m';
      } else if (difference > 0 && difference < 100000) {
        range = 'Increased by < 0.1 ETB m';
      } else if (difference < 0 && difference > -100000) {
        range = 'Decreased by < 0.1 ETB m';
      } else if (difference <= -100000 && difference >= -1000000) {
        range = 'Decreased by 0.1-1 ETB m';
      } else if (difference < -1000000) {
        range = 'Decreased by > 1 ETB m';
      }
    }

    rangeInitiativesMap[range].push(initiative);
  });

  return rangeInitiativesMap;
};

export default ImplementationCostCurrentVsLastweek;
